import * as React from "react";

import { Button } from "./design-system/button";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface Props {
  action?: any;
  afterAction?: any;
  styles?: string;
  text: string;
  childComponent?: Function;
  disabled?: boolean;
  tooltip?: React.ReactElement | null;
  fontAwesomeIcon?: IconProp;
  styleType?: "outline" | "solid";
}

export function ActionButton(props: Props) {
  const [showChildren, setShowChildren] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [complete, setComplete] = React.useState(false);
  const [error, setError] = React.useState("");

  const submitAction = () => {
    const action = props.action;
    if (action != null) {
      setLoading(true);
      setComplete(false);
      setError("");
      action()
        .then((result: { ok: boolean; json: () => unknown }) => {
          if (!result.ok) {
            throw "Error saving request.";
          }
          return result.json();
        })
        .then((result: { ok?: boolean }) => {
          if (result.ok != true) {
            throw "Error saving request.";
          }
          setLoading(false);
          setComplete(true);
          if (props.afterAction) {
            props.afterAction();
          }
        })
        .catch((error: unknown) => {
          console.error(error);
          setLoading(false);
          setError(String(error));
        });
    }
  };

  return (
    <React.Fragment>
      <Button
        styleType={props.styleType || "solid"}
        colorScheme={complete ? "success" : "primary"}
        size="md"
        className="tw-w-full"
        leftIcon={props.fontAwesomeIcon}
        onClick={() => {
          if (props.childComponent != null) {
            setShowChildren(true);
          } else {
            submitAction();
          }
        }}
        disabled={(props.disabled !== undefined && props.disabled) || complete}
        tooltip={props.tooltip}
      >
        {complete ? (
          <div className="tw-w-full">
            <div className="fas fa-check tw-mx-auto tw-text-center"></div>
          </div>
        ) : loading ? (
          <div className="tw-w-full">
            <div className="little-spinner tw-mx-auto tw-text-center"></div>
          </div>
        ) : (
          props.text
        )}
      </Button>
      {error != "" ? (
        <div className="tw-p-[13px] tw-text-red-500">{error}</div>
      ) : null}
      {props.childComponent != null && showChildren === true
        ? props.childComponent(setShowChildren)
        : null}
    </React.Fragment>
  );
}
